function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 13a.5.5 0 01-.492-.41L6 12.5v-3a.5.5 0 01.992-.09L7 9.5V12h5.924V1H7v2.5a.5.5 0 01-.41.492L6.5 4a.5.5 0 01-.492-.41L6 3.5v-3a.5.5 0 01.41-.492L6.5 0h6.925a.5.5 0 01.492.41l.008.09v12a.5.5 0 01-.41.492l-.09.008H6.5zm2.784-3.591a.5.5 0 01-.637-.058l-.058-.069a.5.5 0 01.057-.638l1.649-1.648H1.5a.5.5 0 01-.09-.992l.09-.009 8.793.001-1.647-1.647-.057-.07a.5.5 0 01.765-.637l2.5 2.5.057.07a.5.5 0 01-.057.637l-2.5 2.502z",
  fill: "#54585D",
  fillRule: "nonzero"
})));